import { connect } from "react-redux";

import ZubehoerPayload from "./ZubehoerPayload";

import { statePartToAnalogInputs } from "../model/Zubehoer";

export default connect(state => ({
	analog_inputs: statePartToAnalogInputs(state.ablauf),
	units: state.units
}))(ZubehoerPayload);
